import * as d3 from 'd3'
import 'd3-scale'

const yAxisUnit = 'tCO₂eq'

const gridCss = 'stroke-dark opacity-30'

const buildXAxis = (chart, height, xScale, style = gridCss) => {
  const domain = xScale.domain()
  const minX = domain[0]
  const maxX = domain[domain.length - 1]
  const minTick = minX % 5 === 0 ? minX : minX + (5 - (minX % 5))

  chart
    .append('g')
    .attr('transform', `translate(0, ${height})`)
    .call(
      d3
        .axisBottom(xScale)
        .tickSize(-height)
        .tickValues(d3.range(minTick, maxX + 1, 5))
    ) // implement x axis grid
    .call(g => g.selectAll('.tick line').classed(style, true)) // grid style
    .call(g => g.select('.domain').remove()) // remove x axis line
    .call(g =>
      g
        .selectAll('.tick text') // move x axis labels to the bottom
        .attr('font-size', '12')
        .attr('dy', 15)
    )
}

const buildYAxis = (chart, height, yScale, unit) => {
  let locale = d3.formatLocale({
    decimal: ',',
    thousands: ' ',
    grouping: [3]
  })
  let format = locale.format(',')
  chart
    .append('g')
    .call(
      d3
        .axisLeft(yScale)
        .tickSize(0) // remove y axis ticks
        .tickFormat(data => {
          return format(data)
        })
    )
    .call(g => g.select('.domain').remove()) // remove y axis line
    .call(g => g.attr('font-size', '12'))
  // Chart - Y axis unit
  chart
    .append('g')
    .attr('transform', `translate(-30, -45)`)
    .append('foreignObject')
    .attr('width', '50')
    .attr('height', '50')
    .append('xhtml:div')
    .attr('class', 'label-1')
    .html(unit)
}

export { buildXAxis, buildYAxis, yAxisUnit }
